import { Input } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { useCustomerForm } from '../../../../contexts/customerFormContext'
import { AddressInputFieldProps } from '../../types/addressInputFieldProps'

type AddressCityProps = AddressInputFieldProps

export const AddressCity = ({ isDisabled = false }: AddressCityProps) => {
  const { t } = useTranslation()
  const { customerForm } = useCustomerForm()
  const { FormItem } = customerForm

  return (
    <FormItem
      itemColumnEnd={5}
      itemColumnStart={2}
      label={t('customer_modal.form.address.city.label')}
      name="address.city"
      render={({ field }) => <Input {...field} disabled={isDisabled} size="sm" />}
    />
  )
}
